import PropTypes from "prop-types";
import getFulfilmentIds from "../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../getFulfilmentType";
import AfsFulfilmentStringsMarkup from "../AfsFulfilmentStringsMarkup";
import CoreNonPrimaryFulfilmentStringsMarkup from "../CoreNonPrimaryFulfilmentStringsMarkup";
import PartnerFulfilsFulfilmentStringsMarkup from "../PartnerFulfilsFulfilmentStringsMarkup";

const { CORE_NON_PRIMARY, AFS, PARTNER_FULFILS } = FULFILMENT_TYPE;

const fulfilmentStringMarkupComponentMap = {
  [CORE_NON_PRIMARY]: CoreNonPrimaryFulfilmentStringsMarkup,
  [AFS]: AfsFulfilmentStringsMarkup,
  [PARTNER_FULFILS]: PartnerFulfilsFulfilmentStringsMarkup
};

const FulfilmentStringsMarkup = ({ labelledById, source, seller }) => {
  const { sourceId, sellerId } = getFulfilmentIds({ source, seller });
  const fulfilmentType = getFulfilmentType({ sourceId, sellerId });
  const Component = fulfilmentStringMarkupComponentMap[fulfilmentType];

  return (
    <Component labelledById={labelledById} source={source} seller={seller} />
  );
};

FulfilmentStringsMarkup.propTypes = {
  labelledById: PropTypes.string.isRequired,
  source: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default FulfilmentStringsMarkup;
